import { DashboardComponent } from '@aidkitorg/types/lib/survey';
import React, { useState } from 'react';
import { useDashboards } from '../../../../Contexts/DashboardsContext';
import { useAsyncEffect } from '../../../../Hooks/AsyncEffect';
import { TranslatedDashboardComponentResultWithKey } from '@aidkitorg/aidkit/lib/admin_panel/dashboards';
import { BarChart, Card, CardBody, CardHeader, PieChart } from '@aidkitorg/component-library';
import { Metric } from './Metric';

/**
 * Base dashboard component that handles all common behaviors of dashboard
 * components and decides which type of component to render.
 */
type DashboardComponentCardProps = {
  component: DashboardComponent
}

export const DashboardComponentCard = ({ component }: DashboardComponentCardProps) => {
  const { getDashboardComponentTranslation } = useDashboards()
  const [queryResult, setQueryResult] = useState<TranslatedDashboardComponentResultWithKey | undefined>()

  // This shouldn't happen but in case we render this for a component that isn't a Hero Number kind
  // This is more of a type-assurance for TypeScript
  if (!(component.kind === 'Hero Number' || component.kind === 'Bar Chart' || component.kind === 'Pie Chart')) {
    // Throw an error here
    return (<></>)
  }

  useAsyncEffect(async () => {
    const result = await getDashboardComponentTranslation(component)
    if (result) {
      setQueryResult(result)
    }
    // TODO: handle error
    
  }, [component])
    
  const ComponentToRender = () => {
    switch (component.kind) {
      case 'Hero Number':
        return <Metric component={component} result={queryResult}/>
      case 'Bar Chart':
        // This should be a field type for admin panel dashboards
        const groupKey = component.groups[0].kind === 'Field' && component.groups[0].field || ''
        const summaryKey = queryResult?.summaryKey || ''
        return (
          queryResult ? 
            <BarChart 
              data={queryResult.rows}
              categoryKey={groupKey}
              valueKey={summaryKey}
            /> : 
            <></>
        )
      case 'Pie Chart':
        const nameKey = component.groups[0].kind === 'Field' && component.groups[0].field || ''
        if (queryResult) {
          const dataKey = queryResult.summaryKey
          const processedData = queryResult.rows.map((datum, idx) => ({
            ...datum,
            [dataKey]: datum[dataKey] != null ? Number(datum[dataKey]) : null
          }))

          return <PieChart 
            height={400}
            width={400}
            data={processedData}
            dataKey={dataKey}
            nameKey={nameKey}
          /> 
        } else {
          return <></>
        }

    }
  }

  const title = <div className="text-sm">
    {typeof component.title === 'string' ? component.title : component.title['en']}
  </div>

  return <Card className="rounded-md">
    <CardHeader title={title} />
    <CardBody>
      <ComponentToRender />
    </CardBody>
  </Card>
}
